import { setupGoogletag, setupTargeting } from "./helpers/googletag";
import { setupGtm, setGtmPageViewEvent } from "./helpers/gtm";
import { setupStimulus } from "./helpers/stimulus";
import { carFinder } from "./components/car-finder";
import { workaroundWebkitBug } from "./helpers/workarounds"
import { pruneBonzai, setupTruskinObserver } from "./helpers/bonzai"

// Setup
setupGtm();
setupGoogletag();
setupStimulus();
window.addEventListener("load", function() {
  pruneBonzai();
  setupTargeting();
  setupTruskinObserver();
  workaroundWebkitBug();
  setGtmPageViewEvent();
});

// Components
carFinder();